const hInfo = require("../config/pages").pages

var routes = [{
    name: 'home',
    path: 'index/index.script'
  }, {
    name: 'cadastroOngInicio',
    path: 'cadastro/inicio/cadastro_inicio.script'
  }, {
    name: 'ongs',
    path: 'ongs/ongs.script'
  }, {
    name: 'doadores',
    path: 'doadores/doadores.script'
},{
    name: 'faleConosco',
    path: 'fale-conosco/fale-conosco.script'
  },{
    name: 'termosECondicoes',
    path: 'termos-e-condicoes/termos-e-condicoes.script'
  }, {
    name: 'comoAjudar',
    path: 'como-ajudar/como-ajudar.script'
  }, {
    name: 'quemSomos',
    path: 'quem-somos/quem-somos.script'
  }, {
    name: 'etapa_1',
    path: 'cadastro/etapa_1/etapa_1.script'
  }, {
    name: 'etapa_2',
    path: 'cadastro/etapa_2/etapa_2.script'
  }, {
    name: 'etapa_3',
    path: 'cadastro/etapa_3/etapa_3.script'
  }, {
    name: 'etapa_4',
    path: 'cadastro/etapa_4/etapa_4.script'
  },
  {
    name: 'etapa_4_1',
    path: 'cadastro/etapa_4_1/etapa_4_1.script'
  }, {
    name: 'etapa_5',
    path: 'cadastro/etapa_5/etapa_5.script'
  }, {
    name: 'etapa_6',
    path: 'cadastro/etapa_6/etapa_6.script'
  }, {
    name: 'etapa_7',
    path: 'cadastro/etapa_7/etapa_7.script'
  }, {
    name: 'etapa_8',
    path: 'cadastro/etapa_8/etapa_8.script'
  }, {
    name: 'etapa_9',
    path: 'cadastro/etapa_9/etapa_9.script'
  }, {
    name: '404',
    path: '404/404.script'
  }, {
    name: 'ongFicha',
    path: 'ong-ficha/ong-ficha.script'
  }, {
    name: 'doadorFicha',
    path: 'doador-ficha/doador-ficha.script'
  },
]


const pages = hInfo;


export async function routeLoad(route) {

  try {
    // load pages scripts
    routes.forEach(async (routeInfo) => {
      if (route == routeInfo.name) {
        var script = await require(`../views/pages/${routeInfo.path}`);
        await script.load()
        return true
      }


    })
  } catch (err) {
    return false
  }
}

export async function routeOffload(route) {
  try {
    routes.forEach(async (routeInfo) => {
      if (route == routeInfo.name) {
        var script = await require(`../views/pages/${routeInfo.path}.offload`);
        await script.offload()
        return true
      }
    })
  } catch (err) {
    return false
  }

}
